export const ASSESSMENT = 'Assessment';
export const PRICING = 'Pricing';
export const CORE = 'Core';
export const STORE = 'Store';
